<template>
    <div class="flex justify-end items-center h-16 w-full px-4 border-t border-gray-200 rounded-b shadow-xl">
        <slot />
    </div>
</template>

<script>
    export default {};
</script>
